import React from 'react';
import { AssignmentModel, CaseModel } from 'api/model';
import styled from 'styled-components';
import { useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignment } from 'api/assignment/assignment';
import Button from 'components/inputs/Button';

// right aligned button
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
`;

const ContentWrapper = styled.div`
  margin-bottom: 20px;
`;

type Props = {
  assignment: AssignmentModel;
  caseModel: CaseModel;
  onClose?: () => void;
};

const RemoveFromCarTransportTruckContent: React.FC<Props> = ({
  assignment,
  caseModel,
  onClose,
}) => {
  // api requests
  const unassignRegularAssignmentFromCarTransportTruckAssignmentCall =
    useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignment();

  const handleUnAssign = async () => {
    const carTransportTruckAssignmentId =
      assignment.loadedByTransport?.[0]?.carTransportTruckAssignmentID;
    if (!carTransportTruckAssignmentId) {
      return;
    }
    await unassignRegularAssignmentFromCarTransportTruckAssignmentCall.mutateAsync(
      {
        params: {
          assignmentId: assignment.assignmentID,
          carTransportTruckAssignmentId,
        },
      }
    );
    onClose?.();
  };

  return (
    <div>
      <ContentWrapper>
        <span>
          Är du säker på att du vill ta bort tilldelningen av{' '}
          {caseModel.registrationNumber} till lastbilen?
        </span>
      </ContentWrapper>

      <ButtonWrapper>
        <Button onClick={onClose}>Avbryt</Button>
        <Button
          onClick={handleUnAssign}
          loading={
            unassignRegularAssignmentFromCarTransportTruckAssignmentCall.status ===
            'loading'
          }
        >
          Bekräfta
        </Button>
      </ButtonWrapper>
    </div>
  );
};

export default RemoveFromCarTransportTruckContent;
